export const SHARE_TRACKING_LABEL = 'photo';

export const LIKED_PHOTO_STORAGE_KEY = 'likedPhoto';
